import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';

class TooltipDescricaoErro extends Component{

	constructor(props) {
		super(props);

		this.state = {
			tooltipOpen: false
		};
	}

	toggle = () => {
		this.setState({
			tooltipOpen: !this.state.tooltipOpen
		});
	}

	textoReduzido = () => {
		let txt = this.props.text;
		let txtReduzido;

		if(txt.length > 42){
			txtReduzido = txt.substring(0, 42);
			txtReduzido += "...";
		}
		else{
			txtReduzido = txt;
		}

		return txtReduzido;
	}

	render(){
		return(
			<div>
				<p id={"Tooltip-" + this.props.id}>{this.textoReduzido()}</p>
				<Tooltip className="ecoTooltip" placement="auto" isOpen={this.state.tooltipOpen} target={"Tooltip-" + this.props.id} toggle={this.toggle}>
					{this.props.ToolTipText || this.props.text}
				</Tooltip>
			</div>
		)
	}
}

export default TooltipDescricaoErro;


// WEBPACK FOOTER //
// ./src/Componente/Common/TooltipDescricaoErro.jsx